import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function FinalApprovalPage() {
  return (
    <SalaryIncreasePlaceholder
      title="Final Approval"
      description="Give final sign-off on the period's increases."
    />
  );
}
